import React from "react";
import {
    ResourceType,
    AuditLogChangeType,
    ActorType,
    AuditLogFilter,
} from "@common/types/auditLog";
import {
    AuditLogFilters,
    FilterOption,
    FilterSection,
} from "../AuditLogFilters";
import { FilterSectionType } from "../AuditLogFilters.lib";

interface ReconciliationLogFiltersProps {
    filters: Pick<AuditLogFilter, "resourceType" | "changeType" | "actorType">;
    onChange: (
        filters: Pick<
            AuditLogFilter,
            "resourceType" | "changeType" | "actorType"
        >,
    ) => void;
}

const filterOptions: FilterOption[] = [
    // Resource Types
    {
        id: ResourceType.TRANSACTION,
        label: "Transactions",
        type: FilterSectionType.RESOURCE,
    },
    {
        id: ResourceType.BANK_RECONCILIATION,
        label: "Reconciliations",
        type: FilterSectionType.RESOURCE,
    },

    // Change Types
    {
        id: AuditLogChangeType.CREATE,
        label: "Created",
        type: FilterSectionType.CHANGE,
    },
    {
        id: AuditLogChangeType.UPDATE,
        label: "Updated",
        type: FilterSectionType.CHANGE,
    },
    {
        id: AuditLogChangeType.DELETE,
        label: "Deleted",
        type: FilterSectionType.CHANGE,
    },

    // Actor Types
    { id: ActorType.USER, label: "Users", type: FilterSectionType.ACTOR },
    { id: ActorType.SUPPORT, label: "Support", type: FilterSectionType.ACTOR },
    { id: ActorType.SYSTEM, label: "System", type: FilterSectionType.ACTOR },
];

const filterSections: FilterSection[] = [
    {
        key: "resource",
        title: "Resource Type",
        type: FilterSectionType.RESOURCE,
        filterKey: "resourceType",
    },
    {
        key: "change",
        title: "Action Type",
        type: FilterSectionType.CHANGE,
        filterKey: "changeType",
    },
    {
        key: "actor",
        title: "Actor",
        type: FilterSectionType.ACTOR,
        filterKey: "actorType",
    },
];

export const ReconciliationLogFilters: React.FC<
    ReconciliationLogFiltersProps
> = ({ filters, onChange }) => (
    <AuditLogFilters
        filters={filters}
        onChange={onChange}
        filterOptions={filterOptions}
        filterSections={filterSections}
    />
);
